import React, { useState, useEffect } from 'react';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import * as _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import EmptyState from '../../../images/icons/CommisionIcons/EmptyState.svg';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import plusIcon from '../../../images/icons/plus.svg';
import CommonBtn from '../../LeadProfile/CommonBtn/CommonBtn';
import styles from './Style.module.css';
import AddBankUnit from './AddBankUnit';
import {
  addBankUnitAPI,
  getBankUnitListAPI
} from '../../../common/constants/api';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import PopUp from '../../../common/components/PopUp/PopUp';
import { getAcl } from '../../../common/utils/acl-utils';
import { navigate } from 'gatsby';
import AddCommission from '../AddCommission/AddCommission';
import CommissionSlabWise from '../CommissionBankUnitWise/SlabwiseCommission/CommissionSlabWise';
import CommissionBonus from '../CommissionBonus/CommissionBonus';
import AddCommissionBonus from '../CommissionBonus/AddCommissionBonus';
import UploadDocFi from '../UploadDocFi/UploadDocFi';

const CommissionBankUnitWise = props => {
  const { tableStyle } = styles;
  const [addBankUnitData, setAddBankUnitData] = useState({
    panIndia: false,
    selectZone: { value: '', label: 'Select Zone' },
    selectCity: { value: '', label: 'Select City' },
    branchName: '',
    isGSTApplicable: 'false',
    GSTPercentage: ''
  });

  const [showModal, setShowModal] = useState(false);
  const [showAction, setShowAction] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [tableData, setTableData] = useState([]);
  const dashboardRedirect = () => {
    navigate('/app/commission');
  };

  const [showAddCommission, setShowAddCommission] = useState(false);
  const [fiCurrentSection, setFiCurrSection] = useState('Units');
  const [currentUnitSelected, setCurrUnitSelected] = useState({});
  const [showAddCommissionBonus, setShowAddCommissionBonus] = useState(false);

  async function getAllBankUnitList() {
    setShow(true);
    await getBankUnitListAPI(props.fiId)
      .then(res => {
        setShow(false);
        setTableData(res?._embedded?.financialUnitDetailDtoList);
      })
      .catch(err => {
        setShow(false);
      });
  }

  useEffect(() => {
    getAllBankUnitList();
  }, []);

  async function addBankUnitFun(values) {
    setShow(true);
    setType('loading');
    setText('Please Wait...');
    let body = {
      zoneId: parseInt(values?.selectZone?.value) || 0,
      zoneName:
        values?.selectZone?.value !== '' ? values?.selectZone?.label : '',
      cityId: parseInt(values?.selectCity?.value) || 0,
      cityName:
        values?.selectCity?.value !== '' ? values?.selectCity?.label : '',
      instituteId: parseInt(props?.fiId) || 0,
      branchName: values?.branchName || '',
      panIndia: !!values?.panIndia,
      isGstInclusive: values?.isGSTApplicable,
      gstPercentage: parseFloat(values?.GSTPercentage) || null
    };

    await addBankUnitAPI(body)
      .then(res => {
        getAllBankUnitList();
        setText('Bank Unit has been added successfully!');
        setType('success');
        setTimeout(() => {
          setShow(false);
        }, 2000);
      })
      .catch(err => {
        setShow(false);
      });
  }
  useEffect(() => {
    if (!getAcl()?.acl?.can_access_commission) navigate('/app/dashboard');
  }, []);

  return (
    <React.Fragment>
      <Helmet title={`Dashboard FI | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="widhtMd max-screen flex-1 w-full">
            {fiCurrentSection == 'Units' && showModal && (
              <AddBankUnit
                showModal={showModal}
                setShowModal={setShowModal}
                addBankUnitData={addBankUnitData}
                addBankUnitFun={addBankUnitFun}
              />
            )}
            {fiCurrentSection == 'Slab' && (
              <AddCommission
                showModal={showAddCommission}
                setShowModal={setShowAddCommission}
                fiUnit={props?.fiId}
                setCurrUnitSelected={setCurrUnitSelected}
              />
            )}
            {fiCurrentSection == 'Bonus' && (
              <AddCommissionBonus
                showModal={showAddCommissionBonus}
                setShowModal={setShowAddCommissionBonus}
                fiUnit={props?.fiId}
                setCurrUnitSelected={setCurrUnitSelected}
              />
            )}

            <div className="flex items-center">
              <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 mb-4 mb-0 relative">
                <span
                  className="mr-1 cursor-pointer"
                  onClick={dashboardRedirect}
                >
                  Financial Institutions
                </span>
                <FontAwesomeIcon icon={faAngleDoubleRight} className="mr-1" />
                <span className="text-green-800">{props?.brandName}</span>
              </div>
              <Header />
            </div>

            <div
              className="bg-white py-4"
              style={{
                minHeight: '700px'
              }}
            >
              <div className="flex flex-row xxmd:flex-row sm:flex-col mx-4 justify-between">
                <div className="flex items-center">
                  <div
                    className="w-14 h-14 rounded-full border border-green-600"
                    style={{ background: 'aliceblue' }}
                  />
                  <div className="pl-3">
                    <div className="text-black-850 font-medium">
                      {props?.brandName}
                    </div>
                    <div className="flex flex-col sm:flex-row justify-between text-black-400">
                      <div className="pr-5">FI ID : {props?.fiId}</div>
                      <div className="pr-5">
                        Brand name : {props?.brandName}
                      </div>
                      <div>Legal name : {props?.legalName}</div>
                    </div>
                  </div>
                </div>
                {fiCurrentSection !== 'Document' && (
                  <div className=" w-44 h-12 mr-3 mt-2 cursor-pointer text-center text-white bg-tealCol-100 rounded-md">
                    <div
                      className="mx-auto inline-flex"
                      onClick={() => {
                        if (fiCurrentSection == 'Units') setShowModal(true);
                        else if (fiCurrentSection == 'Slab')
                          setShowAddCommission(true);
                        else if (fiCurrentSection == 'Bonus')
                          setShowAddCommissionBonus(true);
                      }}
                    >
                      <img
                        className="block mr-1 -mt-px"
                        src={plusIcon}
                        alt="+"
                      />
                      <span className="text-base py-3 block">
                        {`${(fiCurrentSection == 'Units' && 'Add Bank units') ||
                          (fiCurrentSection == 'Slab' && 'Add Commission') ||
                          (fiCurrentSection == 'Bonus' && 'Add Bonus')}`}
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <div className=" m-4 flex">
                <CommonBtn
                  value="Slab"
                  stylesBtn={{
                    width: '5rem',
                    textAlign: 'center',
                    display: 'block',
                    color: fiCurrentSection == 'Slab' ? 'white' : '#8D8D8D',
                    background:
                      fiCurrentSection == 'Slab' ? '#FD8023' : 'white',

                    border: '1px solid #CCCCCC',
                    marginRight: '-3px'
                  }}
                  onClick={() => setFiCurrSection('Slab')}
                />
                <CommonBtn
                  value="Units"
                  stylesBtn={{
                    width: '5rem',
                    textAlign: 'center',
                    display: 'block',
                    background:
                      fiCurrentSection == 'Units' ? '#FD8023' : 'white',
                    color: fiCurrentSection == 'Units' ? 'white' : '#8D8D8D',
                    border: '1px solid #CCCCCC',
                    marginRight: '0px'
                  }}
                  onClick={() => setFiCurrSection('Units')}
                />
                {props?.enableCommissionBonus && (
                  <CommonBtn
                    value="Bonus"
                    stylesBtn={{
                      width: '5rem',
                      textAlign: 'center',
                      display: 'block',
                      background:
                        fiCurrentSection == 'Bonus' ? '#FD8023' : 'white',
                      color: fiCurrentSection == 'Bonus' ? 'white' : '#8D8D8D',
                      border: '1px solid #CCCCCC',
                      marginLeft: '-2px'
                    }}
                    onClick={() => setFiCurrSection('Bonus')}
                  />
                )}

                <CommonBtn
                  value="Document"
                  stylesBtn={{
                    width: '5rem',
                    textAlign: 'center',
                    display: 'block',
                    background:
                      fiCurrentSection == 'Document' ? '#FD8023' : 'white',
                    color: fiCurrentSection == 'Document' ? 'white' : '#8D8D8D',
                    border: '1px solid #CCCCCC',
                    marginLeft: '-14px'
                  }}
                  onClick={() => setFiCurrSection('Document')}
                />
              </div>

              {fiCurrentSection == 'Units' && (
                <div
                  className="w-full mx-4 relative m-auto overflow-auto"
                  style={{
                    width: '98%'
                  }}
                >
                  {(!tableData || (tableData && tableData?.length == 0)) && (
                    <div
                      className="flex flex-col items-center justify-center"
                      style={{
                        minHeight: '400px'
                      }}
                    >
                      <img src={EmptyState} alt="" />
                      <p className="text-grey-2231 mt-4">
                        Please add your commission structure
                      </p>
                    </div>
                  )}
                  {tableData?.length > 0 && (
                    <table className={`w-full  ${tableStyle}`}>
                      <thead>
                        <tr className="text-sm">
                          <th className=" px-4 py-4">SL No</th>
                          <th className=" px-4 py-4">Pan India</th>
                          <th className=" px-4 py-4">Unit Name</th>
                          <th className=" px-2 py-2">Zone</th>
                          <th className=" px-2 py-2">City</th>
                          <th className=" px-2 py-2">Branch</th>
                          <th className=" px-2 py-2">GST(inclusive)</th>
                          <th className=" px-2 py-2">Corporate Margin %</th>
                          <th className=" px-2 py-2">Attachment</th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {tableData &&
                          tableData.map((each, index) => {
                            const {
                              panIndia,
                              unitName,
                              zoneName,
                              cityName,
                              branchName,
                              isGstInclusive,
                              gstPercentage
                            } = each;
                            return (
                              <tr
                                key={index}
                                className="hover:bg-grey-1009 font-roboto font-normal text-xs text-black-850"
                              >
                                <td className="px-4 py-4">{index + 1}</td>
                                <td className="px-2 py-4">
                                  {panIndia ? panIndia.toString() : '-'}
                                </td>
                                <td className="px-2 py-4">{unitName}</td>
                                <td className="px-2 py-4">
                                  {zoneName ? zoneName : '-'}
                                </td>
                                <td className="px-2 py-4">
                                  {cityName ? cityName : '-'}
                                </td>
                                <td className="px-2 py-4">
                                  {branchName ? branchName : '-'}
                                </td>
                                <td className="px-2 py-4">
                                  {isGstInclusive === true
                                    ? `${gstPercentage} %`
                                    : 'false'}
                                </td>
                                <td className="px-2 py-4">-</td>
                                <td className="px-2 py-4 text-orange-1100">
                                  {/* <AttachFileIcon
                                  style={{
                                    color: '#FD8023',
                                    height: '17px',
                                    width: '17px'
                                  }}
                                /> */}
                                  -
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
              {fiCurrentSection == 'Slab' && (
                <CommissionSlabWise
                  fiUnit={props?.fiId}
                  currentUnitSelected={currentUnitSelected}
                />
              )}
              {fiCurrentSection == 'Bonus' && (
                <CommissionBonus
                  fiUnit={props?.fiId}
                  currentUnitSelected={currentUnitSelected}
                />
              )}

              {fiCurrentSection == 'Document' && (
                <UploadDocFi fiId={props?.fiId} />
              )}
            </div>
          </div>
        </div>
      </div>
      <PopUp type={type} text={text} show={show} setShow={setShow} />
    </React.Fragment>
  );
};

export default withErrorHandler(CommissionBankUnitWise);
